// Typing CarrotQuest
export interface Carrotquest {
  connect: (apiKey: string) => void
  track: (eventName: string, params: object) => void
  identify: (data: object | object[]) => void
  auth: (userId: string, hash: string) => void
  open: () => void
  onReady: (callback: () => void) => void
  addCallback: (topic: string, callback: () => void) => void
  removeCallback: (topic: string, callback: () => void) => void
  trackMessageInteraction: (
    sendingId: string,
    type: 'read' | 'replied' | 'clicked',
  ) => void
}

export enum CqType {
  hide = 'none',
  show = 'block',
}
